<template>
	<div class="dashboard-category">
		<p>{{title}}</p>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'CategoryBlock',
		props: {
			title: {
				type: String,
				required: true
			}
		}
	}
</script>

<style lang="scss">
	.dashboard-category {
		@apply bg-dashboard-gray-lighter rounded-dashboard-md px-12 pt-5 pb-12;

		& > p {
			@apply text-2xl text-dashboard-gray-darker mb-2;
		}
	}
</style>